<template>
    <div class="page my-service">

        <div class="my-service-title">Hi，你来了~</div>
        <div class="my-service-desc">
            <div>欢迎添加下方客服微信</div>
            <div>反馈您遇到的问题/建议，我们将尽快给您回复~</div>
        </div>

        <div class="my-service-kf">
            <img src="/static/bytx/kefu.svg" alt="">
        </div>

    </div>
</template>

<script>
    import Interface from "@/util/interface"
    export default {
        name: 'my-service',
        data() {
            return {
                value: "",
            }
        },
        created() {
            Interface.getShareInfo(this,"","","")
        }
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/service/index.vue